import { render, staticRenderFns } from "./AddShiftBasedConsumptionTableWidget.vue?vue&type=template&id=5dbb35ec"
import script from "./AddShiftBasedConsumptionTableWidget.vue?vue&type=script&lang=js"
export * from "./AddShiftBasedConsumptionTableWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports